module.exports = __webpack_public_path__ + "static/alexwork3-e80c2a1a5e74cf568d29f64a29a5fcd1.jpg";